export default "__VITE_ASSET__CkLOydxn__"